// extracted by mini-css-extract-plugin
export default {"wrapper":"Bik52 ZdH1P","item":"fYPOH"};